import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import {
  ChartTooltip,
  ChartTooltipContent,
  ChartContainer,
  ChartConfig
} from '@/components/ui/chart';
interface PieData {
  name: string;
  value: number;
  color: string;
}

interface PieProps {
  data: PieData[];
  width?: string;
  height?: string;
  innerRadius?: number;
  outerRadius?: number;
  startAngle?: number;
  endAngle?: number;
  showLegend?: boolean;
  legendPosition?: 'top' | 'bottom' | 'left' | 'right';
}

const PieChartComponent: React.FC<PieProps> = ({
  data,
  width = '100%',
  height = '100%',
  innerRadius = 30,
  outerRadius = 45,
  startAngle = 90,
  endAngle = 450,
  showLegend = true,
  legendPosition = 'right'
}) => {
  // 动态生成 chartConfig
  const chartConfig: ChartConfig = {
    ...data.reduce(
      (config, item) => {
        config[item.name] = {
          label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
          color: item.color
        };
        return config;
      },
      {} as Record<string, { label: string; color: string }>
    )
  };
  const renderLegend = () => {
    if (!showLegend) return null;

    return (
      <div
        className={`flex ${
          legendPosition === 'right'
            ? 'flex-col'
            : legendPosition === 'left'
              ? 'flex-col'
              : legendPosition === 'top'
                ? 'flex-row'
                : 'flex-row'
        } gap-1`}
      >
        {data.map((entry, index) => (
          <div key={`legend-${index}`} className="flex items-center gap-1">
            <div className="h-2 w-2 rounded-sm" style={{ backgroundColor: entry.color }}></div>
            <span className="text-xs text-[#1F1F1F]">{entry.name}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="flex items-center gap-4">
      <div style={{ width, height }}>
        <ResponsiveContainer width="100%" height="100%">
          <ChartContainer
            config={chartConfig}
            className={`aspect-square ${legendPosition === 'right' ? 'flex-1' : ''}`}
            style={{ maxHeight: height }}
          >
            <PieChart>
              <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                dataKey="value"
                startAngle={startAngle}
                endAngle={endAngle}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ChartContainer>
        </ResponsiveContainer>
      </div>
      {renderLegend()}
    </div>
  );
};

export default PieChartComponent;
